import SearchEngine from "../components/SearchEngine";

function SearchCards() {
    return (
      <div>
        <h1>Search Cards</h1>
        <SearchEngine />
      </div>
    );
  }
  
  export default SearchCards;